// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".permissions[data-v-2b48e42d]{margin:10px}.permissions p[data-v-2b48e42d]{margin:5px}.permissions span[data-v-2b48e42d]{color:#409eff}.permissions .el-button-group[data-v-2b48e42d]{margin:5px}.permissions ul[data-v-2b48e42d]{margin:5px 0 0 25px}.permissions ul li[data-v-2b48e42d]{margin:10px 0}", ""]);
// Exports
module.exports = exports;
